import React, { useContext, useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { createClassForHSForm } from "../utils/requests/form";
import "../Hubspot.css"
import Form from "../utils/forms/handleForm";
import { postCompletion } from "../utils/requests/completions";
import { CompletionsContext, ThemeContext, ContactIdContext, LoadingContext } from "../App"
import { FormTitleContext } from "../layout/Vertical/Global";
import { MsalInstanceContext, VariablesContext } from "../auth/AppProvider";
import { SetTrakingHubspot } from "../utils/functions/trackingHubspot";
import HandleErrorsMessage from "./Completion/HandleErrorsMessage";
import { withTranslation } from "react-i18next";
import { getStripeStatus } from "../utils/requests/stripe";
import { CheckIcon, QuestionMarkCircleIcon, PencilSquareIcon, BellAlertIcon } from "@heroicons/react/24/outline";
import { ArrowLeftIcon } from "@heroicons/react/24/solid";
import Alert from "../components/Alert/Alert";

export const FormLoadingContext = React.createContext();

function Completion({ t }) {
    const [countdown, setCountdown] = useState({
        days: '00',
        hours: '00',
        minutes: '00',
        seconds: '00',
    });
    const scrollToTop = useRef()
    const [completion, setCompletion] = useState({});
    const [, setFormTitle] = useContext(FormTitleContext);
    const [step, setStep] = useState(0);
    const [form, setForm] = useState({});
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState(null);
    const [pageLoading, setPageLoading] = useContext(LoadingContext);
    const [formLoading, setFormLoading] = useState(false);
    const [infoSaved, setInfoSaved] = useState(false);
    const [isVisible, setIsVisible] = useState(false);
    const [stepWorkingOn, setStepWorkingOn] = useState(-1);

    let navigate = useNavigate();
    let { id, checkoutid } = useParams();

    const [completions, setCompletions] = useContext(CompletionsContext);
    const contactId = useContext(ContactIdContext);
    const theme = useContext(ThemeContext);
    const msalInstance = useContext(MsalInstanceContext);
    const variables = useContext(VariablesContext);

    useEffect(() => {
        setIsVisible(false);
        const timer = setTimeout(() => {
            setIsVisible(true);
        }, 250);

        return () => clearTimeout(timer);

    }, []);

    function toTheTop() {
        if (scrollToTop.current) {
            scrollToTop.current.scrollIntoView({ behavior: 'smooth' });
        }
    }

    function getTimeRemaining(date) {
        const target = new Date(date + "T23:59:59");
        const time = target.getTime() - new Date().getTime(),
            days = Math.floor(time / 1000 / 60 / 60 / 24),
            hours = Math.floor((time / 1000 / 60 / 60) % 24),
            minutes = Math.floor((time / 1000 / 60) % 60),
            seconds = Math.floor((time / 1000) % 60);
        return {
            time,
            days,
            hours,
            minutes,
            seconds,
        };
    }

    useEffect(() => {
        createClassForHSForm(theme);
        var completionCurr = completions && completions.find(c => c.id === id);
        var formCurr = {};
        if (completionCurr && completionCurr.steps && completionCurr.steps[0]) {
            if (checkoutid && checkoutid !== "cancel") {
                setPageLoading(true);
                if (completionCurr.steps.find(st => st.questions.find(q => q.label === "Paybox"))) {
                    var index = completionCurr.steps.findIndex(st => st.questions.find(q => q.label === "Paybox" && q.fieldType === "custom input"))
                    if (index >= 0 && completionCurr.steps[index]) {
                        setStep(index);
                        setStepWorkingOn(index);
                        formCurr = completionCurr.steps[index];
                    } else {
                        formCurr = completionCurr.steps[0];
                    }
                    setCompletion(completionCurr);
                    setForm(formCurr);
                    setPageLoading(false);
                } else if (completionCurr.steps.find(st => st.questions.find(q => q.label === "Stripe"))) {
                    getStripeStatus(msalInstance, variables, completionCurr.objectAssociated.objectId, checkoutid).then(res => {
                        if (res) {
                            var index = completionCurr.steps.findIndex(st => st.questions.find(q => q.label === "Stripe" && q.fieldType === "custom input"))
                            if (index >= 0 && completionCurr.steps[index]) {
                                setStep(index);
                                setStepWorkingOn(index);
                                formCurr = completionCurr.steps[index];
                            } else {
                                formCurr = completionCurr.steps[0];
                            }
                            setCompletion(completionCurr);
                            setForm(formCurr);
                            setPageLoading(false);
                        } else {
                            navigate("/");
                        }
                    })
                }

            }
            else {
                setStep(completionCurr.step);
                setStepWorkingOn(completionCurr.step);
                formCurr = completionCurr.steps[completionCurr.step];
                setCompletion(completionCurr);
                setForm(formCurr);
            }
            var endDate = formCurr?.endDate;
            if (endDate) {
                const time = getTimeRemaining(completionCurr.variables?.find(v => v.id === endDate)?.value);
                setCountdown({
                    days: time.days,
                    hours: time.hours,
                    minutes: time.minutes,
                    seconds: time.seconds,
                });
            }
        } else {
            navigate("/")
        }
    }, [id, completions, theme, navigate, t, checkoutid, msalInstance, variables]);

    useEffect(() => {
        if (completion && completion.parameters) {
            setFormTitle(completion.label)
            SetTrakingHubspot(msalInstance, variables.HSTenantID, variables.ClientName, completion.label + " - Etape : " + form?.name);
        }
    }, [variables, completion, msalInstance, step, form])

    function handleChangeStep(locstep) {
        setInfoSaved(false);
        if (locstep > stepWorkingOn) {
            setStepWorkingOn(locstep);
        }
        setLoading(true);
        if (locstep < 0) {
            locstep = 0
        }
        setStep(() => {
            if (completion.steps && completion.steps.length >= locstep) {
                setForm(completion.steps[locstep])
                setErrors(null);
                setLoading(false);
                toTheTop()
                return locstep;
            } else {
                navigate("/");
            }
        });
        if (completion.steps[locstep]?.endDate) {
            const time = getTimeRemaining(completion.variables?.find(v => v.id === completion.steps[locstep].endDate)?.value);
            setCountdown({
                days: time.days,
                hours: time.hours,
                minutes: time.minutes,
                seconds: time.seconds,
            });
        }
    }

    function canNavigateBackTo(targetStep) {
        if (!completion?.steps || targetStep < 0 || targetStep >= step) return false;
        for (let i = targetStep + 1; i <= step; i++) {
            if (!completion.steps[i]?.canGoBack) {
                return false;
            }
        }
        return true;
    }

    function handleSt(res, newStep, cl) {
        var stepCL = Object.assign({}, res.steps.find(s => s?.questions?.find(sq => sq.id === cl.block)));
        var questionCL = Object.assign({}, stepCL?.questions?.find(sq => sq?.id === cl?.block));
        if (questionCL && Object.keys(questionCL).length > 0) {
            if (!newStep?.questions.find(q => q?.id === questionCL?.id)) {
                questionCL.hidden = true;
                questionCL.readonly = true;
                questionCL.required = false;
                questionCL.conditional = true;
                questionCL.conditionalList = [cl];
                newStep?.questions.push(questionCL)

            } else {
                var questionNIndex = newStep?.questions?.findIndex(q => q.id === questionCL.id);
                var questionN = newStep?.questions[questionNIndex]
                if (questionNIndex > -1) {
                    newStep?.questions?.splice(questionNIndex, 1);
                }
                questionN?.conditionalList?.push(cl);
                newStep.questions.splice(questionNIndex, 0, questionN);
            }
            if (cl.and) {
                newStep = handleSt(res, newStep, cl.and)
            }
        }
        return newStep
    }


    function handleSubmit(formData) {
        setInfoSaved(false);
        setErrors(false);
        setLoading(true);
        var data = {};
        data.step = step;
        data.contactId = contactId;
        var cand = completion;
        cand.steps.forEach(step => {
            step.questions.forEach(question => {
                if (formData[question.name] !== undefined)
                    question.value = formData[question.name]
            })
        })
        data.candidature = cand;
        data.properties = cand.properties;
        return postCompletion(msalInstance, variables, data).then(res => {
            if (res.ok) {
                return res.json()
            } else {
                if (res.status === 401) {
                    const baseUrl = window.location.origin + '/';
                    window.location.replace(baseUrl);
                } else {
                    return res.json().then(err => {
                        if (err && err.noteError) {
                            setErrors([err.message]);
                            completion.noteError = err.noteError;
                            setCompletion(completion);
                        } else {
                            setErrors([err]);
                        }
                        setLoading(false);
                        throw err;
                    })
                }
            }
        }).then(res => {
            if (res) {
                try {
                    var index = completions.findIndex(c => c.id === res.id);
                    var completionsLocal = completions;
                    completionsLocal[index] = res;
                    setCompletions(completionsLocal)
                    setCompletion(res);
                    if ((res.step + 1 >= res.steps.length) || (res.steps && res.steps[step] && res.steps[step].canGoNext)) {
                        setStep(s => {
                            if (res.finished) {
                                if (res.steps && res.steps.length === 1) {
                                    var newStep = res.steps[0]
                                    setForm(newStep);
                                    setLoading(false);
                                    setStepWorkingOn(0);
                                    return 0;
                                } else {
                                    navigate("/");
                                }
                            } else {
                                var stepToGo = res.step > s ? res.step : s + 1;
                                if (stepToGo >= res.steps.length) {
                                    navigate("/");
                                } else {
                                    var newStep = res?.steps[stepToGo]
                                    if (newStep?.questions?.find(q => q?.fieldType === "custom input" && q?.object === "Logic")) {
                                        newStep?.questions.filter(q => q?.fieldType === "custom input" && q?.object === "Logic").forEach(q => {
                                            q?.conditionalList?.forEach(cl => {
                                                newStep = handleSt(res, newStep, cl)
                                            })
                                        })
                                    }
                                    var questions = [];
                                    newStep?.questions.forEach(q => {
                                        if (q.fieldType !== "custom input" && q.fieldType !== "custom variable" && q.optionsCustomList?.length !== 1 && res?.steps?.find(s => s?.questions?.find(qq => qq.name === q.name && qq.id !== q.id))) {
                                            q.value = res?.steps?.find(s => s?.questions?.find(qq => qq.name === q.name && qq.id !== q.id))?.questions?.find(qq => qq.name === q.name && qq.id !== q.id)?.value;
                                        }
                                        questions.push(q)
                                    })
                                    newStep.questions = questions
                                    setForm(newStep)
                                    setLoading(false);
                                    setStepWorkingOn(stepToGo);
                                    handleChangeStep(stepToGo);
                                    return stepToGo;
                                }
                            }
                        });
                    } else {
                        const currentStepRes = res.steps[step];
                        const nextStepRes = res.steps[step + 1];
                        const hasPipelineGap =
                            currentStepRes?.pipelineEnd &&
                            nextStepRes?.pipelinePrerequisite &&
                            currentStepRes.pipelineEnd !== nextStepRes.pipelinePrerequisite;

                        if (hasPipelineGap) {
                            navigate("/");
                        } else {
                            setLoading(false);
                            setInfoSaved(true);
                        }
                    }
                    return true
                }
                catch (e) {
                    navigate("/");
                }
            } else {
                throw false;
            }
        }).catch(err => {
            if (err != null && typeof err === "string")
                setErrors([err]);
            else if (err && err.message)
                setErrors([err.message]);
            else
                setErrors(["Veuillez rafraichir la page et réessayer"]);
            setLoading(false);
            throw err;
        })
    }

    return pageLoading || (completion && completion.steps && step >= completion.steps.length) ? null : <div className={isVisible ? "my-forms-visible layout" : "hidden"}>
        <section className="xl:grid grid-cols-2 xl:gap-8 pb-12 xl:pb-24" ref={scrollToTop}>
            <div className="xl:mt-12 ">
                <div className="flex-auto">
                    <h1 className="page-title">{completion.label}</h1>
                </div>
                <div className="xl:grid xl:grid-cols-2 xl:gap-5 mt-12 xl:mt-0 w-full relative pr-4 hidden">
                    <div className="">
                        <div className="flow-root">
                            <ul key="listquestion" className="-mb-8 mt-4">
                                {completion?.steps?.map((stepL, stepIdx) => (
                                    <li key={stepIdx}>
                                        <div className="relative pb-8">
                                            {stepIdx !== completion?.steps.length - 1 ? (
                                                <span aria-hidden="true" className="absolute left-4 top-4 -ml-px h-full w-0.5 bg-gray-800" />
                                            ) : null}
                                            <div
                                                className={`relative flex space-x-3 ${stepIdx < stepWorkingOn
                                                    ? (stepIdx < step && !canNavigateBackTo(stepIdx) ? 'cursor-not-allowed' : 'cursor-pointer')
                                                    : (stepIdx === stepWorkingOn && stepWorkingOn !== step ? 'cursor-pointer' : '')
                                                    }`}
                                                onClick={() => {
                                                    if (stepIdx < stepWorkingOn) {
                                                        if (stepIdx >= step || canNavigateBackTo(stepIdx)) handleChangeStep(stepIdx);
                                                    } else if (stepIdx === stepWorkingOn && stepWorkingOn !== step) {
                                                        handleChangeStep(stepIdx);
                                                    }
                                                }}
                                            >
                                                <div>
                                                    {stepIdx < stepWorkingOn ? (
                                                        <button
                                                            className={`flex h-8 w-8 items-center justify-center rounded-full ring-8 ring-white ${stepIdx < step && !canNavigateBackTo(stepIdx) ? 'bg-green-300' : 'bg-green-500'}`}
                                                            style={{ cursor: 'inherit' }}
                                                        >
                                                            <CheckIcon className="h-5 w-5 text-white" />
                                                        </button>
                                                    ) : stepIdx === stepWorkingOn ? (
                                                        <span
                                                            className='flex h-8 w-8 items-center justify-center rounded-full ring-8 ring-white bg-gray-900'
                                                        >
                                                            <PencilSquareIcon className="h-5 w-5 text-white" />
                                                        </span>
                                                    ) : (
                                                        <span
                                                            className='flex h-8 w-8 items-center justify-center rounded-full ring-8 ring-white bg-gray-900'
                                                        >
                                                            <QuestionMarkCircleIcon className="h-5 w-5 text-white" />
                                                        </span>
                                                    )}
                                                </div>
                                                <div className="text-left pt-1.5">
                                                    <div>
                                                        <p className={stepIdx < step ? "text-sm font-bold text-green-500" : (stepIdx === step ? "text-sm font-bold color-primary-perso" : "text-sm")}>
                                                            {stepL.name}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="xl:hidden mt-4">
                    <ol className="flex items-center">
                        {completion?.steps?.map((stepL, stepIdx) => (
                            <li key={stepIdx} className={`${stepIdx !== completion.steps.length - 1 ? 'flex-1' : ''} relative`}>
                                {stepIdx < stepWorkingOn ? (
                                    <>
                                        <div aria-hidden="true" className="absolute inset-0 flex items-center">
                                            <div className={`h-0.5 w-full ${stepIdx < step && !canNavigateBackTo(stepIdx) ? 'bg-green-100' : 'bg-green-500'}`} />
                                        </div>
                                        <button
                                            onClick={() => {
                                                if ((stepIdx >= step || canNavigateBackTo(stepIdx)) && !loading) handleChangeStep(stepIdx);
                                            }}
                                            className={`relative flex h-8 w-8 items-center justify-center rounded-full ${stepIdx < step && !canNavigateBackTo(stepIdx) ? 'bg-green-300' : 'bg-green-500'} ${stepIdx === step ? 'ring-2 ring-green-500' : ''}`}
                                        >
                                            <CheckIcon aria-hidden="true" className="h-5 w-5 text-white" />
                                        </button>
                                    </>
                                ) : stepIdx === stepWorkingOn ? (
                                    <>
                                        <div aria-hidden="true" className="absolute inset-0 flex items-center">
                                            <div className="h-0.5 w-full bg-gray-200" />
                                        </div>
                                        <button
                                            onClick={() => { if (stepWorkingOn !== step && !loading) handleChangeStep(stepIdx); }}
                                            aria-current="step"
                                            className={`relative flex h-8 w-8 items-center justify-center rounded-full border-2 border-primary-perso bg-white ${stepIdx === step ? 'ring-2 ring-primary-perso' : ''}`}
                                        >
                                            <span aria-hidden="true" className="h-2.5 w-2.5 rounded-full bg-primary-perso" />
                                        </button>
                                    </>
                                ) : (
                                    <>
                                        <div aria-hidden="true" className="absolute inset-0 flex items-center">
                                            <div className="h-0.5 w-full bg-gray-200" />
                                        </div>
                                        <button
                                            disabled
                                            className="group relative flex h-8 w-8 items-center justify-center rounded-full border-2 border-gray-300 bg-white"
                                        >
                                        </button>
                                    </>
                                )}
                            </li>
                        ))}
                    </ol>
                </div>
            </div>
            <div className="mb-12 xl:mb-0 xl:mt-12 xl:mx-4 container-box relative overflow-hidden">
                <div>
                    {completion ? <div className="pt-5 flex gap-2">
                        {completion?.steps && completion?.steps?.length <= step && step > 0 && canNavigateBackTo(step - 1) ? <ArrowLeftIcon className="xl:hidden h-6 w-6 text-gray-600 pt-1 cursor-pointer" onClick={() => { handleChangeStep(step - 1) }} /> : null}
                        <h1 style={{ fontSize: "1.5rem", lineHeight: "2rem", fontWeight: 600, marginBottom: ".5rem" }}>{completion.steps && completion.steps.length >= step ? completion.steps[step]?.name : null}</h1>
                    </div> : null}
                    {completion.steps?.[step]?.endDate && countdown.days < 7 ? <div className='text-xs text-bold text-red-500 flex items-center '>
                        <BellAlertIcon className="h-5 w-5 inline-block mr-1 tilt-shaking" />
                        {countdown.days > 0 ?
                            <span className='font-bold'>Plus que {countdown.days} jour{countdown.days > 1 ? "s" : ""} pour remplir cette étape</span> :
                            countdown.hours > 0 ?
                                <span className='font-bold'>Plus que {countdown.hours}h pour remplir cette étape</span> :
                                <span className='font-bold'>Plus que {countdown.minutes} minutes pour remplir cette étape</span>
                        }
                    </div> : null}
                    {errors ? <HandleErrorsMessage errors={errors} /> : <></>}
                    <div className="">
                        {form && form.questions ? <FormLoadingContext.Provider value={[formLoading, setFormLoading]}>
                            {infoSaved && <Alert type="success" title={t("Informations enregistrées")} />}
                            <div className="z-10">
                                <Form form={form.questions} handleSubmit={handleSubmit} theme={theme} contactId={contactId} candidature={completion.objectAssociated} dealId={completion.objectAssociated.objectId} templateId={completion.templateId} formId={completion.id} loading={loading ? true : false} msalInstance={msalInstance} currentStep={step} amountSteps={completion?.steps?.length} setStep={handleChangeStep} toTheTop={toTheTop} back={canNavigateBackTo(step - 1)} next={completion?.steps[step]?.canGoNext} nextStepBack={completion?.steps[step + 1]?.canGoBack} secondaryObjects={completion.secondaryObjects} />
                            </div>
                        </FormLoadingContext.Provider> : null}
                        <div className={formLoading || loading ? "absolute left-0 top-0 bottom-0 right-0 bg-gray-700 text-white z-30 opacity-50 flex justify-center items-center" : "loading-end"}>
                            <div className="loaderlogo" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
}

export default withTranslation()(Completion);